import { FC } from 'react';

import LocationDisplay from 'components/LocationDisplay/LocationDisplay';

import { Job } from 'types/jobs';

import styles from './OptionJobWithLocation.module.scss';

interface OptionJobWithLocationProps {
  job: Job;
}

const OptionJobWithLocation: FC<OptionJobWithLocationProps> = ({
  job
}: OptionJobWithLocationProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{job.title}</div>
      <LocationDisplay
        countryCode={job.country?.code}
        location={job.location}
        className={styles.location}
        isFlagAtEnd
      />
    </div>
  );
};

export default OptionJobWithLocation;
